<template>
  <b-nav-item :to="to" :title="title">
    <v-icon :name="icon" width="16" />
    <span class="sm-hidden">{{ title }}</span>
  </b-nav-item>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>
